export const parseDecimal = (value) => {
  return value.match(/^[-+]?[0-9]*\.?[0-9]+$/g) ? parseFloat(value) : value;
}